module.exports = __webpack_public_path__ + "img/11.4b86ea7e.png";